import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { getFeatureFlag, getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations, UnleashFlags } from '../models/feature-flag.models'
import { createIntegrationConfigIfFlagEnabled } from '../helpers/integration-helpers'

const integrationFlagSuffix = 'oos-webinar'

const getExtensionVersion = () => {
  const useUnleash = getFeatureFlag(UnleashFlags.OOS_USE_UNLEASH, false)

  return useUnleash
    ? getFeatureFlag(UnleashFlags.OOS_WEBINAR_VERSION, 'release')
    : getLaunchDarklyFlag(LaunchDarklyVariations.OOS_WEBINAR_VERSION)
}

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-webinar-app',
  get url() {
    const version = getExtensionVersion()
    return new URL(getOOSArtifactUrl('webinar-extension', version))
  },
  prerequisites: {
    [PrerequisiteRuleTypes.ENTITLEMENTS]: 'g2w',
    accountSettings: 'webinar.isWebinarGoToAppEnabled',
  },
  get integrationConfig() {
    return createIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
  },
}

export default extensionConfig
